import Swal from "sweetalert2";

export function overrideBlocklyVariables(t: any, language: string = "en") {
  if (window.Blockly.Msg && language === "tr") {
    window.Blockly.Msg.DELETE_BLOCK = "Bloğu Sil";
    window.Blockly.Msg.DELETE_X_BLOCKS = "%1 Bloğu Sil";
    window.Blockly.Msg.DUPLICATE_BLOCK = "Çoğalt";
    window.Blockly.Msg.DUPLICATE_COMMENT = "Yorumu Çoğalt";
    window.Blockly.Msg.ADD_COMMENT = "Yorum Ekle";
    window.Blockly.Msg.REMOVE_COMMENT = "Yorumu Kaldır";
    window.Blockly.Msg.EXTERNAL_INPUTS = "Dış Girişler";
    window.Blockly.Msg.INLINE_INPUTS = "İç Girişler";
    window.Blockly.Msg.COLLAPSE_BLOCK = "Bloğu Daralt";
    window.Blockly.Msg.EXPAND_BLOCK = "Bloğu Genişlet";
    window.Blockly.Msg.COLLAPSE_ALL = "Blokları Daralt";
    window.Blockly.Msg.EXPAND_ALL = "Blokları Genişlet";
    window.Blockly.Msg.DISABLE_BLOCK = "Bloğu Devre Dışı Bırak";
    window.Blockly.Msg.ENABLE_BLOCK = "Bloğu Etkinleştir";
    window.Blockly.Msg.HELP = "Yardım";
    window.Blockly.Msg.UNDO = "Geri Al";
    window.Blockly.Msg.REDO = "Yinele";
    window.Blockly.Msg.CLEAN_UP = "Blokları Düzenle";
  }

  window.Blockly.dialog.setConfirm((message: any, callback: any) => {
    Swal.fire({
      title: message,
      showCancelButton: true,
      confirmButtonText: t("ok"),
      cancelButtonText: t("cancel"),
    }).then((result) => {
      callback(result.isConfirmed);
    });
  });

  window.Blockly.dialog.setPrompt(
    (message: any, defaultValue: any, callback: any) => {
      Swal.fire({
        title: message,
        input: "text",
        inputValue: defaultValue || "",
        showCancelButton: true, // <-- sende false idi, iptal butonu görünmüyordu
        confirmButtonText: t("ok"),
        cancelButtonText: t("cancel"),
        inputValidator: (value) => {
          if (!value) {
            return t("pleaseEnterAValue");
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          callback(result.value);
        } else {
          callback(null);
        }
      });
    }
  );
}
